import { ApiError } from './apiErrorClass';
import { ErrorContent, ResponseError } from './types';

export const handleApiError = async (response: Response) => {
  const json = (await response.json()) as ResponseError;
  throw new ApiError(json);
};

export const getErrorContent = (responseError: unknown): ErrorContent => {
  const errorContent: ErrorContent = {
    title: '',
    subtitle: '',
    body1: '',
    body2: ''
  };

  if (responseError instanceof ApiError) {
    errorContent.title = `${responseError?.code}.title`;
    errorContent.subtitle = `${responseError?.code}.subtitle`;
    errorContent.body1 = `${responseError?.code}.body1`;
    errorContent.body2 = `${responseError?.code}.body2`;
  }

  return errorContent;
};
